import { updatesData } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '新片上架': 'bg-primary-100 text-primary-700',
  '剧集更新': 'bg-accent-100 text-accent-700',
  '功能更新': 'bg-secondary-100 text-secondary-700',
  '站点公告': 'bg-background-200 text-foreground-600',
  '专题上线': 'bg-accent-100 text-accent-700',
  '系统维护': 'bg-background-200 text-foreground-600',
  '热门完结': 'bg-primary-100 text-primary-700',
  '经典上线': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新动态</h2>
          <div className="w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>
        </div>
        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[15px] md:left-[19px] top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-6">
            {updatesData.map((item, idx) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12 group">
                <div className={`absolute left-[11px] md:left-[14px] top-1.5 w-[9px] h-[9px] md:w-[11px] md:h-[11px] rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500' : 'bg-background-300 group-hover:bg-primary-400 transition-colors'
                }`}></div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 border border-background-200/70 group-hover:border-primary-200 transition-all duration-200">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-1.5">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-800">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}